module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d6f0362fc2114f39b4f6651ebeda312.svg";